<template>
  <v-list-item
    link
    class="pa-0 mt-1"
    :to="item.para"
    :data-cy="item.datacy"
  >
    <v-list-item-title
      class="px-0 py-3 text-wrap"
      :class="$vuetify.breakpoint.lgAndUp ? 'subtitle-1' : ''"
    >
      {{ item.label }}
    </v-list-item-title>
    <v-list-item-icon class="my-auto mb-0">
      <v-icon class="display-1">
        mdi-chevron-right
      </v-icon>
    </v-list-item-icon>
  </v-list-item>
</template>

<script>
export default {
  name: 'ListaItem',

  props: {
    item: {
      type: Object,
      required: true,
    },
  },
};
</script>
